import { Toast } from 'components/Modal';
import { apiClient, useTitle } from 'modules';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

interface Record {
  nickname: string;
  create_time: string;
  delete_time: number;
  status: number;
}

export default function InvitationList() {
  useTitle('我邀请的用户');

  const [list, setList] = useState<Record[]>([]);
  const [count, setCount] = useState();
  const [message, setMessage] = useState('');
  const [toastVisible, setToastVisible] = useState(false);

  function showToast(newMessage: string) {
    setMessage(newMessage);
    setToastVisible(true);

    setTimeout(() => {
      setToastVisible(false);
    }, 2000);
  }

  async function fetchCount() {
    const response = await apiClient.invite.award();

    if (response.status !== 10000) {
      showToast(response.msg);
      return;
    }

    setCount(response.body.count);
  }

  async function fetchList() {
    const response = await apiClient.invite.list();

    if (response.status !== 10000) {
      showToast(response.msg);
      return;
    }

    setList(response.body);
  }

  useEffect(() => {
    fetchCount();
    fetchList();
  }, []);

  function status(item: Record) {
    if (item.status === 3) {
      return '已提现';
    }

    if (item.delete_time === 0) {
      return '已关注';
    }

    return '已取关';
  }

  return (
    <div className={styles.container}>
      <Toast isOpen={toastVisible} message={message} />
      <div className={styles.title}>
        您已成功邀请&nbsp;<span className={styles.count}>{count}</span>&nbsp;人
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>昵称</th>
            <th>状态</th>
            <th>接受邀请时间</th>
          </tr>
        </thead>
        <tbody>
          {list.map((item, index) => (
            <tr key={index}>
              <td>{item.nickname}</td>
              <td
                className={cx(
                  styles.status,
                  (item.delete_time === 0 || item.status === 3) &&
                    styles.disabled
                )}
              >
                {status(item)}
              </td>
              <td>{item.create_time}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
